import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CreateFlowcodeFormField } from '../../CreateFlowcodeForm.types'
import { FC } from 'react'
import { FileDestinations, LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'
import { SORTED_SIMPLIFIED_SCAN_DESTINATIONS } from './ScanDestination.contants'
import { ScanDestinationIcon } from './ScanDestinationIcons'
import { ScanDestinationV1Props } from '../Simplified.types'
import { Select } from '@dtx-company/shared-components/src/components/atoms/Select/index'
import { SelectOption } from '@dtx-company/shared-components/src'
import { SimplifiedScanDestinationFormV1 } from './ScanDestinationForm'
import { arrowDownBlue, arrowUpBlue } from '@app/page/src/assets/icons'
import { getFormField } from '../CreateCode.utils'
import {
  useCreateFlowcodeForm,
  useCreateFlowcodeStateActions
} from '../../CreateFlowcodeForm.hooks'
import { useCreateFlowcodeState } from '../../../../../hooks/useCreateFlowcodeState'

export const SimplifiedScanDestinationV1: FC<ScanDestinationV1Props> = ({
  variant,
  destinations = SORTED_SIMPLIFIED_SCAN_DESTINATIONS,
  onChange,
  onInputChange
}) => {
  const { destination: selectedDestination } = useCreateFlowcodeState()
  const { setDestination: setSelectedDestination } = useCreateFlowcodeStateActions()
  const { clearErrors, setValue } = useCreateFlowcodeForm()

  const handleDestinationChange = (selectedOption: SelectOption): void => {
    const field = getFormField(selectedOption.value as LandingPageDestination)
    // reset field validation errors
    clearErrors(field)
    // reset input on destination change
    if (selectedDestination.id in FileDestinations) {
      setValue(field, null)
    } else {
      setValue(field, '')
      setValue(CreateFlowcodeFormField.SocialMediaId, '')
    }
    const newDestination = destinations.find(destination => destination.id === selectedOption.value)
    setValue(CreateFlowcodeFormField.SocialMediaId, selectedOption.value)
    if (newDestination) {
      onChange?.(newDestination)
      setSelectedDestination(newDestination)
    }
  }

  const selectOptions: SelectOption[] = destinations.map(destination => ({
    label: destination.label,
    value: destination.id,
    icon: <ScanDestinationIcon destination={destination.id} />
  }))

  const defaultSelectOption = selectOptions.find(option => option.value === selectedDestination.id)

  return (
    <Box alignItems={'flex-start'} width="100%">
      <Select
        name={CreateFlowcodeFormField.SocialMediaId}
        options={selectOptions}
        defaultValue={defaultSelectOption}
        onChange={handleDestinationChange}
        selectContainerProps={{
          width: '180px',
          borderRadius: '4px 0 0 4px',
          color: 'primary.flowBlue'
        }}
        selectButtonProps={{
          borderRight: 'none',
          borderRadius: 'inherit',
          color: 'inherit',
          bg: 'inherit',
          'data-testid': 'dropdown-wrapper'
        }}
        iconDownSrc={arrowDownBlue}
        iconUpSrc={arrowUpBlue}
      />
      <Box width={'calc(100% - 138px)'}>
        <SimplifiedScanDestinationFormV1
          selectedDestination={selectedDestination}
          variant={variant}
          onInputChange={onInputChange}
        />
      </Box>
    </Box>
  )
}
